import TrackingService from '@/services/tracking';
import { theme } from '@/styles';
import { EnterShops } from '@/types';
import GridListBox from '@/ui/GridListBox';
import Image from '@/ui/Image';
import React from 'react';
import styled from 'styled-components';

interface EnterShopProps {
  title: string;
  data?: EnterShops[];
  handleLinkOpen: (value: string) => void;
  gtmValue?: Record<string, any>;
}

const EnterShop = ({
  title,
  data,
  handleLinkOpen,
  gtmValue,
}: EnterShopProps) => {
  return (
    <GridListBox
      title={title}
      gridNum={4}
      imgList={data}
      isAmount={true}
      disabled={data ? data.length < 5 : false}
      gtmName="shop_entered_agent"
      gtmValue={gtmValue}
    >
      {({ item }: { item: EnterShops }) => (
        <Container
          onClick={() => handleLinkOpen(`/shop/${item.id}`)}
          {...TrackingService.tagGTM('shop_entered_agent_list_item_button', {
            'shop-id': item.id,
            ...gtmValue,
          })}
        >
          <Image
            src={`https:${item?.image.url}`}
            alt={`eventRollingBanner`}
            width="177px"
            height={'177px'}
            style={{ borderRadius: '2px' }}
            objectFit="cover"
          />
          <StoreType>{item.type.name}</StoreType>
          <StoreName>{item.name}</StoreName>
          <StoreBadge>
            {item.badges.map(
              (items, idx) =>
                idx < 2 && <Badge key={`badge${idx}`}>{items.text}</Badge>,
            )}
          </StoreBadge>
        </Container>
      )}
    </GridListBox>
  );
};

export default EnterShop;

const Container = styled.div`
  cursor: pointer;
`;

const StoreType = styled.div`
  margin-top: 16px;
  color: ${theme.colors.neutral_colors.gray[700]};
  ${theme.typography.body2};
`;

const StoreName = styled.div`
  margin-top: 4px;
  color: ${theme.colors.accent_colors.primary.default};
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${theme.typography.subtitle6};
`;

const StoreBadge = styled.div`
  display: flex;
  gap: 4px;
`;

const Badge = styled.div`
  margin-top: 8px;
  padding: 4px 8px;
  border-radius: 2px;
  color: ${theme.colors.accent_colors.blue.default};
  background-color: ${theme.colors.accent_colors.blue.light};
  ${theme.typography.caption2};
`;
